import { createFileRoute, notFound } from '@tanstack/react-router'
import { getStaticPage } from '@/src/lib/static-pages'
import { Markdown } from '@/src/components/Markdown'
import { NotFound } from '@/src/components/NotFound'
import { useTranslation } from '@/src/i18n/client'

export const Route = createFileRoute('/_static/docs/api')({
  loader: () => {
    const enPage = getStaticPage('api', 'en')
    const dePage = getStaticPage('api', 'de')
    
    if (!enPage && !dePage) {
      throw notFound()
    }
    
    return { enPage, dePage }
  },
  head: ({ loaderData }) => ({
    meta: [
      { title: loaderData?.enPage?.title || 'API Documentation - GearLens' },
      { name: 'description', content: loaderData?.enPage?.description || 'Drawing Analysis & Integration' }
    ],
  }),
  component: ApiDocs,
})

function ApiDocs() {
  const { i18n } = useTranslation()
  const { enPage, dePage } = Route.useLoaderData()
  
  const currentLocale = i18n.language.split('-')[0]
  const page = currentLocale === 'de' ? dePage : enPage
  
  if (!page) {
    return <NotFound />
  }

  return (
    <Markdown 
      content={page.content} 
      className="prose prose-gray dark:prose-invert max-w-none"
    />
  )
}
